import { render, staticRenderFns } from "./DiagnosticoDigital.vue?vue&type=template&id=304ec338&scoped=true&"
import script from "./DiagnosticoDigital.vue?vue&type=script&lang=js&"
export * from "./DiagnosticoDigital.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticoDigital.vue?vue&type=style&index=0&id=304ec338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304ec338",
  null
  
)

export default component.exports